import paymentIcons from 'assets/images/payment/payment_icons.png';
import facebook from 'assets/images/social/facebook.png';
import instagram from 'assets/images/social/instagram.png';
import tiktok from 'assets/images/social/tiktok.png';
import twitter from 'assets/images/social/twitter.png';
import youtube from 'assets/images/social/youtube.png';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="px-6 pt-6 pb-3 bg-common">
      <div className="mx-auto max-w-screen-xl w-full">
        <div className="grid gap-8 grid-cols-2 sm:grid-cols-4 lg:text-left text-slate-600">
          <div className="text-white">
            <h4 className="text-lg font-semibold mb-2 text-white">
              JANOVA LIMITED
            </h4>
            <p className="mb-2">
              We specialize in providing the best payment and shipping solutions
              from factory to consumer.
            </p>
            <div className="flex items-start gap-2 mb-2">
              <span className="font-medium">Call us:</span>
              <div>
                <p>+1 (812) 813 0010</p>
                <p>+852 9290 3251</p>
              </div>
            </div>
            <p className="font-medium">WhatsApp: +852 9290 3251</p>
          </div>

          <div className="text-white">
            <h4 className="text-lg font-semibold mb-2 text-white">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about-us" className="hover:text-orange-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/return-refund-policy"
                  className="hover:text-orange-200"
                >
                  Return & Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/shipping-policy" className="hover:text-orange-200">
                  Shipping Policy
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-orange-200">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-services" className="hover:text-orange-200">
                  Terms of Services
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="hover:text-orange-200">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div className="text-white">
            <h4 className="text-lg font-semibold mb-2 text-white">
              Our Community
            </h4>
            <p>Coming soon</p>
          </div>
          <div className="text-white">
            <h4 className="text-lg font-semibold mb-2 text-white">
              Connect with us
            </h4>
            <div className="flex gap-2 flex-wrap">
              <img src={instagram} alt="instagram" className='h-8 text-white cursor-pointer' loading="lazy" />
              <img src={facebook} alt="facebook" className='h-8 text-white cursor-pointer' loading="lazy" />
              <img src={twitter} alt="twitter" className='h-8 text-white cursor-pointer' loading="lazy" />
              <img src={tiktok} alt="tiktok" className='h-8 text-white cursor-pointer' loading="lazy" />
              <img src={youtube} alt="youtube" className='h-8 text-white cursor-pointer' loading="lazy" />
            </div>
          </div>
        </div>
        <div className='mt-3 flex gap-x-3 justify-center flex-wrap'>
          <img src={paymentIcons} alt="payment" loading="lazy" className="h-10" />
          {/* <img src={stripeImg} alt="stripe" loading="lazy" className="h-8" />
          <img src={paypalImg} alt="paypal" loading="lazy" className="h-8" /> */}
          {/* <img src={amExpress} alt="stripe" loading="lazy" className="h-14" />
          <img src={discover} alt="stripe" loading="lazy" className="h-14" />
          <img src={masterCard} alt="stripe" loading="lazy" className="h-14" />
          <img src={visa} alt="stripe" loading="lazy" className="h-14" /> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
